import axiosInstance from "../api/authAPI";
import {
  CreateSurveyResponse,
  FetchHistorySurveyParams,
  FetchSurveyParams,
  GenerateReportResponse,
  GenerateSurveyReportResponse,
  SubmitSurveyResponse,
  SurveyListResponse,
} from "../types/surveyTypes";
interface SurveyDropDown {
  id: number; // use `key` from API as `id` here
  name: string;
}
export const fetchSurveyList = async (
  params: FetchSurveyParams,
): Promise<SurveyListResponse> => {
  try {
    const response = await axiosInstance.get<SurveyListResponse>("/surveys", {
      params,
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to fetch survey list";
  }
};
//fetch survey history list
export const fetchHistorySurveyList = async (
  params: FetchHistorySurveyParams,
): Promise<SurveyListResponse> => {
  try {
    const response = await axiosInstance.get<SurveyListResponse>(
      "/get-submit-forms",
      {
        params,
      },
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to fetch survey list";
  }
};

// delete survey
export const deleteSurvey = async (id: number): Promise<SurveyListResponse> => {
  try {
    const response = await axiosInstance.delete(`/surveys/${id}`);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Survey deletion failed" };
  }
};

// create survey
export const createSurveyAPI = async (
  formData: FormData,
): Promise<CreateSurveyResponse> => {
  try {
    const response = await axiosInstance.post("/surveys", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || "Survey creation failed";
  }
};

// update survey
export const updateSurvey = async (
  id: number,
  userData: FormData,
): Promise<CreateSurveyResponse> => {
  try {
    const response = await axiosInstance.post<CreateSurveyResponse>(
      `/surveys/${id}`,
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || "Survey update failed";
  }
};

// survey dropdownlist
export const fetchSurveyDropdownList = async (
  project_id?: number | null,
  is_form_creation: boolean = false,
  survey_id?: number | null | undefined,
): Promise<SurveyDropDown[]> => {
  const params: Record<string, any> = {
    is_form_creation: is_form_creation ? 1 : 0,
  };
  if (project_id != null) {
    params.project_id = project_id;
  }
  if (survey_id != null) {
    params.survey_id = survey_id;
  }
  const response = await axiosInstance.get("/surveys-list", { params });
  const data = response.data;

  if (data.status) {
    return data.data.map((survey: any) => ({
      id: survey.key,
      name: survey.name,
    }));
  } else {
    throw new Error(data.message || "Failed to fetch survey list");
  }
};

//get survey details
export const fetchSurveyDetails = async (
  id: number,
): Promise<CreateSurveyResponse> => {
  try {
    const response = await axiosInstance.get<CreateSurveyResponse>(
      `/surveys/${id}`,
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Survey update failed";
  }
};
// export survey
export const generateSurveyReport = async (
  project_id: string,
  survey_id: string,
  start_date?: string,
  end_date?: string,
  is_admin?: number,
): Promise<GenerateSurveyReportResponse> => {
  try {
    const response = await axiosInstance.get<GenerateSurveyReportResponse>(
      "/generate-survey-report",
      {
        params: {
          project_id,
          survey_id,
          start_date,
          end_date,
          is_admin,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to generate survey report";
  }
};
// fetch report
export const generateReport = async (
  project_id: string,
  survey_id: string,
  report_id: string,
  is_admin?: number,
): Promise<GenerateReportResponse> => {
  try {
    const response = await axiosInstance.get<GenerateReportResponse>(
      "/survey-detail-report",
      {
        params: {
          project_id,
          survey_id,
          report_id,
          is_admin,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to generate survey report";
  }
};

// get submit survey by id
export const getSubmitSurveyDetails = async (
  submission_id: number,
): Promise<SubmitSurveyResponse> => {
  try {
    const response = await axiosInstance.get<SubmitSurveyResponse>(
      `/get-submit-form-details/${submission_id}`,
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to fetch submit survey";
  }
};
